<ng-container *ngIf="eventBooking?.bookingAttendees?.length > 0">

  <h6 class=""><strong>Podatki o udeležencih:</strong></h6>
  <ion-row class="" *ngFor="let bookingAttendee of eventBooking.bookingAttendees; let i = index; let count = count">
    <ion-col size="11" (click)="openAttendeeEditor( provider, event, eventBooking, 'edit', bookingAttendee)" style="border: 1px dashed;" class="ion-padding clickable" >
      {{ i + 1 }}. <strong>{{ bookingAttendee.composeNameSummaryLine() }}</strong>&nbsp;<small>{{ bookingAttendee.composeContactSummaryLine() }}</small> · <small>{{ bookingAttendee.composeAddressSummaryLine() }}</small><ion-icon name="pencil-outline" style="margin-left:5px;"></ion-icon>
    </ion-col>
    <ion-col size="1" style="padding-left:10px" class="clickable ion-padding-top ion-padding-bottom" (click)="removeAttendee(i)"><ion-icon name="trash-outline" style="margin-left:0px;"></ion-icon>
    </ion-col>
  </ion-row>

  


</ng-container>

<ion-row class="" *ngIf="event.spots > eventBooking?.bookingAttendees?.length">
    <ion-col size="11" style="border: 1px dashed;" class="ion-padding clickable" (click)="openAttendeeEditor( provider, event, eventBooking, 'add')"><span *ngIf="eventBooking?.bookingAttendees?.length > 0"><ion-icon name="add-outline" style="margin-right:5px;"></ion-icon>
      Vpiši dodatnega udeleženca</span><span *ngIf="eventBooking?.bookingAttendees?.length == 0">
      Vpiši podatke za prvega udeleženca</span><ion-icon name="pencil-outline" style="margin-left:5px;"></ion-icon>
    </ion-col><ion-col size="1"></ion-col>
</ion-row>